module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.2c7b246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_hero_600.png
// module id = Jah/
// module chunks = 0